import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import NewPayments from '../../../images/newDesign/new_payments.svg';
import RecurringPayments from '../../../images/newDesign/recurring_payments.svg';
import { useAccessToken } from '../../../common/hooks/useAccessToken';
import { CurrencyValue } from '../../../common/currencyValue';
import { constants } from '../../../common/constants/constants';
import { showLoader, hideLoader } from '../../../store/common/slice';
import BllinkUtils from '../../../common/utils/utils';
import { StyledTodayStats } from './TodayStats.styled';
import LastAction from './LastAction';

const Strings = BllinkUtils.Strings;

const TodayStats = ({ buildingID }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const client = useAccessToken();

    const [newPayments, setNewPayments] = useState(0);
    const [recurringPayments, setRecurringPayments] = useState(0);
    const [lastPaymentsArray, setLastPaymentsArray] = useState([]);
    const [currency, setCurrency] = useState(constants.defaultCurrency);

    const lastPaymentsMock = [
        {
            expense: true,
            amount: 50000,
            currency: 'ils',
            vendorName: 'Gardner'
        },
        {
            expense: false,
            amount: 10000,
            currency: 'ils',
            apartmentNum: '1'
        }
    ];

    useEffect(async () => {
        if (!client) return;

        dispatch(showLoader());
        const payments = await client.managers.dashboard.getTodayPaymentsTotal(buildingID);
        if (payments) {
            setNewPayments(payments?.newPayments?.value);
            setRecurringPayments(payments?.recurringPayments?.value);
        }

        // TODO: uncomment when backend is ready
        // const { lastPayments } = await client.managers.dashboard.getLastPayments(buildingID);
        // if (lastPayments) {
        //     setLastPaymentsArray(lastPayments)
        //     setCurrency(lastPayments[0].currency)
        // }
        setLastPaymentsArray(lastPaymentsMock)

        dispatch(hideLoader());
    }, [client]);

    const renderLastActions = (payment, i) => {
        return <LastAction key={i} payment={payment} />
    };

    return (
        <StyledTodayStats>
            <div className='today-stats-title'>{t('buildings.today_stats')}</div>
            <div className='stats'>
                <div className='detailed-stats'>
                    <img src={NewPayments} />
                    <div>
                        <div className='title'>{t('buildings.new_payments')}</div>
                        <div className='num'><CurrencyValue currency={currency}>{newPayments}</CurrencyValue></div>
                    </div>
                </div>
                <div className='detailed-stats'>
                    <img src={RecurringPayments} />
                    <div>
                        <div className='title'>{t('buildings.recurring_payments')}</div>
                        <div className='num'><CurrencyValue currency={currency}>{recurringPayments}</CurrencyValue></div>
                    </div>
                </div>
            </div>
            <div className='today-stats-title'>{t('buildings.last_actions')}</div>
            <div className='last-actions'>
                {lastPaymentsArray.length === 0 && t('reports.empty_table')}
                {lastPaymentsArray.length > 0 && lastPaymentsArray.map((payment, i) => renderLastActions(payment, i))}
            </div>
        </StyledTodayStats>
    )
}

export default TodayStats;